import httpRequest from 'httpRequest'
import { TenantIdentifierInfoContract } from 'models'
import {
    CompanyTenantIdentifierID,
    LocationTenantIdentifierID,
} from 'types/storeTypes'

export const setTenantToHttpRequest = async (
    tenantInfo: TenantIdentifierInfoContract,
) => {
    httpRequest.setHeader({
        key: CompanyTenantIdentifierID,
        value: tenantInfo.companyTenantIdentifierID!!,
    })
    httpRequest.setHeader({
        key: LocationTenantIdentifierID,
        value: tenantInfo.locationTenantIdentifierID!!,
    })
}
